import http from '../../utils/http';

export default {
    /**
     * 登录
     *
     * @param {*} data
     * @returns
     */
    login(data) {
        return http({
            url: 'Login/Login',
            method: 'GET',
            params: data
        });
    },
    /**
     * 注册
     *
     * @param {*} data
     * @returns
     */
    register(data) {
        return http({
            url: 'Login/Register',
            method: 'GET',
            params: data
        });
    },
    /**
     * 获取验证码
     *
     * @param {*} data
     * @returns
     */
    getPhoneCode(data) {
        return http({
            url: 'Login/GetMsgCode',
            method: 'GET',
            params: data
        });
    },
    /**
     * 找回密码-验证手机号
     *
     * @param {*} data
     * @returns
     */
    verificationPhone(data) {
        return http({
            url: 'Login/VerificationPhone',
            method: 'GET',
            params: data
        });
    },
    /**
     * 修改密码
     *
     * @param {*} data
     * @returns
     */
    setPassword(data) {
        const url = data.code ? 'Login/SetPassword2' : 'Login/SetPassword';
        return http({
            url,
            method: 'GET',
            params: data
        });
    },
    /**
     * 获取注册协议
     *
     * @returns
     */
    getRegistarAgreement() {
        return http({
            url: 'Login/GetRegisterAgreement',
            method: 'GET'
        });
    }
};
